import config from '../../config';
import { APIResponse } from '../../services/api';

export interface LoginSuccess {
  user: User;
  message: 'USER_AUTHORIZED';
  token: string;
  logout?: string;
  status: 'ok';
}

export interface LoginNotFound {
  user: null;
  message: 'USER_NOT_REGISTERED';
  token: null;
  create: string;
  status: 'ok';
}

export interface MailNotValidated {
  user: {
    email: string;
    cuit: string;
  };
  message: 'MUST_VERIFY_EMAIL';
  token: null;
  edit: string;
  status: 'ok';
}

export type LoginResponse = LoginSuccess | LoginNotFound | MailNotValidated;

export interface User {
  id: number;
  email: string;
  telefono: string | null;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
  cuit: string;
  name: string | null;
  address: string | null;
  photo: string | null;
}

async function authenticate(provider: string) {
  const response = await fetch(`${config.autenticar.url}/${provider}`, {
    headers: {
      Authorization: `Bearer ${config.autenticar.key}`,
    },
  });

  return response.json();
}

async function authorize(token: string) {
  const response = await fetch(`${config.api.url}/login`, {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${token}`,
    },
  });

  return (await response.json()) as APIResponse<LoginResponse>;
}

async function register(data: Record<string, string>) {
  const { url, ...values } = data;

  const response = await fetch(url, {
    method: 'post',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(values),
  });

  return (await response.json()) as APIResponse<LoginSuccess>;
}

async function changeEmail(data: Record<string, string>) {
  const { url, ...values } = data;

  const response = await fetch(url, {
    method: 'post',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(values),
  });

  return (await response.json()) as APIResponse<MailNotValidated>;
}

async function resend(token: string) {
  const response = await fetch(`${config.api.url}/usuarios/reenviar`, {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${token}`,
    },
  });

  return (await response.json()) as APIResponse;
}

const loginAPI = {
  authenticate,
  authorize,
  register,
  changeEmail,
  resend,
};

export default loginAPI;
